import { useTranslation } from "react-i18next";
import LegalContent from "./LegalContent";
import SEO from "../app/SEO";

export default function CookiePolicy() {
    const { t } = useTranslation("legal");
    const sections: any[] = t("policies.cookies.sections", { returnObjects: true });
    
        return (
            <>
                <SEO title={{ title: t("policies.cookies.fullTitle"), pageTitle: t("policies.cookies.fullTitle") }} canonicalPath="/legal/cookie-policy" />
                <LegalContent
                    title={t("policies.cookies.title")}
                    updated={t("lblUpdated", { date: t("policies.cookies.updated") })}
                    sections={sections} />
            </>
        );
}